import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal'
import Button from 'react-bootstrap/lib/Button'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import Image from 'react-bootstrap/lib/Image'
import Switch from 'react-switch'
import ResendEmail from '../components/ResendEmail.js'
import { showResendEmailModal } from '../actions/resendEmail.js'
import { closeAccountModal, selectActiveBuilding, selectCommunicationPreferences, handleReceiveNewsletterSwitch } from '../actions/account.js'
import { logout } from '../actions/auth.js'
import { handleInactiveEventsSwitch } from '../actions/account.js'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './Account.css'

class Account extends Component {
  static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  showResendEmail() {
    const { dispatch } = this.props
    dispatch(showResendEmailModal())
  }

  closeAccountModal() {
    const { dispatch } = this.props
    dispatch(closeAccountModal())
  }

  logout() {
    const { dispatch } = this.props
    dispatch(closeAccountModal())
    dispatch(logout())
  }

  handleInactiveEventsSwitch(checked) {
    const { dispatch } = this.props
    dispatch(handleInactiveEventsSwitch(this.props.account._id, checked))
  }

  /* this function takes the building as parameter and dispatch the selectActiveBuilding from actions/account */

  selectActiveBuilding(event) {
    const { dispatch } = this.props
    dispatch(selectActiveBuilding(this.props.account._id, event))
  }
  selectCommunicationPreferences(event) {
    const { dispatch } = this.props
    dispatch(selectCommunicationPreferences(this.props.account._id, event))
  }

  handleReceiveNewsletterSwitch(checked) {
    const { dispatch } = this.props
    dispatch(handleReceiveNewsletterSwitch(this.props.account._id, checked))
  }

  render() {
    let account = this.props.account
    if (account && (account.email || account.invitation)) {
      let needsValidation = account.status === 'requiresActivation' || account.status === 'requiresManualActivation'
      let displayResendEmail = false
      let needsValidationMessage = ''

      if (needsValidation) {
        if (account.status !== 'requiresActivation' && account.active) {
          needsValidationMessage = 'We are validating your requested access, you will receive an email when completed.'
        } else {
          needsValidationMessage = 'You need to verify your email address to continue.'
          displayResendEmail = true
        }
      }
      const communicationPreferences = ['email', 'notification', 'both']

      return (
        <div style={{ height: 120, width: 200 }}>
          <Modal
            keyboard={!needsValidation}
            backdrop={needsValidation ? 'static' : true}
            show={this.props.showAccountModal}
            onHide={this.closeAccountModal.bind(this)}>
            <Modal.Header closeButton={!needsValidation} />
            <Modal.Body>
              <Grid fluid={true}>
                <Row>
                  <Col>
                    <div className='text-center'>
                    {
                        account.image ?
                        <Image thumbnail src={account.image} onError={(e) =>  e.target.src="../images/guestAvatar.png"} circle className='center-block profile-picture' />
                        :
                        <Image src='/images/guestAvatar.png' circle thumbnails className='center-block profile-picture' /> 
                    }
                    </div>
                  </Col>
                </Row>
                {needsValidation ? (
                  <div>
                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className='text-center'>{needsValidationMessage}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                    {displayResendEmail ? (
                      <Row>
                        <Col xs={12}>
                          <Button bsStyle='primary' block onClick={this.showResendEmail.bind(this)}>
                            Resend Email
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col>&nbsp;</Col>
                      </Row>
                    )}
                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                  </div>
                ) : (
                  <div>
                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                      <Col xs={8}>Username:</Col>
					  {account.fullName ? <Col xs={4}>{account.fullName.replace(/\b\w/g, (l) => l.toUpperCase())}</Col> : <Col xs={4}>{account.invitation}</Col> }                      
                    </Row>

                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                    {account.companies && account.companies.length > 0 ? (
                      <Row>
                        <Col xs={8}>Companies:</Col>
                        <Col xs={4}>{account.companies.map((c) => c.name).join(',')}</Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col />
                      </Row>
                    )}

                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                    {account.buildings && account.buildings.length > 0 ? (
                      <Row>
                        <Col xs={8}>Buildings:</Col>
                        <Col xs={4}>{account.buildings.map((b) => b.name).join(',')}</Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col />
                      </Row>
                    )}
                    <Row>
                      <Col>&nbsp;</Col>
                      <Col xs={8}>Communication Preferences:</Col>
                      <Col xs={4}>
                        <div className='dropdown'>
                          <button
                            className='btn btn-default dropdown-toggle'
                            type='button'
                            id='dropdownMenuButton'
                            data-toggle='dropdown'
                            aria-haspopup='true'
                            aria-expanded='false'>
                            {this.props.account.communicationPreferences ? (
                              <div>{this.props.account.communicationPreferences}</div>
                            ) : (
                              <div>'Select Communication Preferences'</div>
                            )}
                          </button>
                          <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                            {communicationPreferences.map((commPref) => (
                              <div className='dropdown-item' onClick={this.selectCommunicationPreferences.bind(this, commPref)}>
                                {commPref}
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {account.buildings && account.buildings.length > 0 ? (
                      /* this row allows us to select the active building */
                      <Row>
                        <Col>&nbsp;</Col>
                        <Col xs={8}>Active building:</Col>
                        <Col xs={4}>
                          <div className='dropdown'>
                            <button
                              className='btn btn-default dropdown-toggle'
                              type='button'
                              id='dropdownMenuButton'
                              data-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'>
                              {this.props.account.activeBuilding ? (
                                <div>{this.props.account.activeBuilding.name}</div>
                              ) : (
                                <div>'Select active building'</div>
                              )}
                            </button>
                            <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                              {account.buildings.map((b) => (
                                <div className='dropdown-item' onClick={this.selectActiveBuilding.bind(this, b._id)}>
                                  {b.name}
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col />
                      </Row>
                    )}
                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                      <Col xs={8}>Send me the community manager newsletter via email:</Col>
                      <Col xs={4}>
                        <Switch onChange={this.handleReceiveNewsletterSwitch.bind(this)} checked={account.receiveNewsletter} id='normal-switch' />
                      </Col>
                    </Row>
                    {account.role == 'program_manager' ? (
                      <Row>
                        <Col xs={8}>
                          <span>Show Unapproved Events</span>
                        </Col>
                        <Col xs={4}>
                          <Switch onChange={this.handleInactiveEventsSwitch.bind(this)} checked={account.showUnapprovedEvents} id='normal-switch' />
                        </Col>
                      </Row>
                    ) : (
                      <div />
                    )}
                    <Row>
                      <Col>&nbsp;</Col>
                    </Row>
                  </div>
                )}
                <Row>
                  <Col xs={12}>
                    <Button bsStyle='primary' block onClick={this.logout.bind(this)}>
                      Log Out
                    </Button>
                  </Col>
                </Row>
              </Grid>
            </Modal.Body>
            <Modal.Footer />
          </Modal>
          <ResendEmail />
        </div>
      )
    } else {
      return <div />
    }
  }

}
const mapStateToProps = (state) => {
  return { ...state.accountReducer, account: state.authReducer.account }
}

export default withRouter(connect(mapStateToProps)(Account))



// WEBPACK FOOTER //
// ./src/components/Account.js